<template>
  <div :style="{
      width: cardWidth + 'px',
      height: cardHeight + 'px'
    }"
    class="overflow-hidden"
  >
    <span
      v-for="(rect, indx) in rectangles" :key="indx"
      :class="['pointer-events-none inline-block absolute bg-[#000000]', fadeColor ? 'opacity-25' : '']"
      :style="{
        top: rect.top + 'px',
        left: rect.left + 'px',
        width: rect.width + 'px',
        height: rect.height + 'px'
      }">
    </span>
  </div>
</template>

<script src="./bezels-mask.js"></script>
